module.exports = __webpack_public_path__ + "img/user.b2be4ab8.png";